import React from "react";
import OutboundPendingFile from "../../../components/OutboundPendingFile/OutboundPendingFile";

const OutboundPendingFilePage = () => {
  return <OutboundPendingFile />;
};

export default OutboundPendingFilePage;
